// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
  position: relative;
  width: 100%;
}
.select.error .select__active {
  border-color: #ff0000;
}
.select__active {
  display: inline-block;
  width: 100%;
  padding: 27px 23px 13px 23px;
  background: var(--primary-color);
  border-radius: 8px;
  outline: none;
  z-index: 1;
  cursor: pointer;
  font-weight: 500;
  font-size: 15px;
  line-height: 149.68%;
  color: #F9F9F9;
  transition: all 0.3s ease;
  border: 1px solid #2B2B2B;
}
.select__active:hover {
  border-color: #EAEAEA;
}
.select__active:hover svg path {
  stroke: #F9F9F9;
}
.select__active:focus ~ span, .select__active:not(:placeholder-shown) ~ span {
  font-size: 11px;
  line-height: 18px;
  font-weight: 600;
  color: #F9F9F9;
  transform: translateY(-12px);
}
.select input {
  position: absolute;
  left: 0;
  top: 0;
  outline: none;
  border: none;
  display: inline-block;
  width: 100%;
  padding: 29px 23px 12px 23px;
  background: var(--primary-color);
  border-radius: 8px;
  outline: none;
  z-index: 1;
  font-weight: 500;
  font-size: 15px;
  line-height: 149.68%;
  color: #F9F9F9;
}
.select input:focus ~ span, .select input:not(:placeholder-shown) ~ span {
  font-size: 11px;
  line-height: 18px;
  font-weight: 600;
  color: #F9F9F9;
  transform: translateY(-12px);
}
.select__arrow {
  position: absolute;
  display: flex;
  align-items: center;
  right: 15px;
  top: 0;
  bottom: 0;
  margin: auto 0;
}
.select__current {
  margin-top: 6px;
  font-weight: 400;
  font-size: 15px;
  line-height: 100%;
  color: #F9F9F9;
}
.select__label {
  position: absolute;
  width: 100%;
  top: 14px;
  left: 23px;
  font-weight: 600;
  font-size: 11px;
  line-height: 120%;
  color: #F9F9F9;
  text-transform: uppercase;
  transition: all 0.3s ease;
  z-index: 2;
  -webkit-user-select: none;
          user-select: none;
}
.select__items {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  width: 100%;
  left: 0;
  top: 110%;
  margin: 10px 0;
  padding: 10px 0px;
  background: var(--primary-color);
  border-radius: 8px;
  transform: scale(0.95);
  transition: all 0.3s ease;
  z-index: 10;
  box-shadow: 0px 4px 8px 0px rgba(34, 60, 80, 0.1);
  overflow-y: auto;
  max-height: 385px;
  border: 1px solid #2B2B2B;
}
.select__item {
  padding: 16px 23px;
  border-radius: 8px;
  cursor: pointer;
}
.select__item:hover {
  background: var(--accent-color);
  color: #fff;
}
.select.active .select__items {
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Select/Select.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;EACA,WAAA;AAFF;AAII;EACE,qBAAA;AAFN;AAKE;EACE,qBAAA;EACA,WAAA;EACA,4BAAA;EACA,gCCfG;EDgBH,kBAAA;EAEA,aAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;AAJJ;AAKI;EAEE,qBAAA;AAJN;AAOQ;EACE,eAAA;AALV;AAUM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;AARR;AAaE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,4BAAA;EACA,gCCzDG;ED0DH,kBAAA;EAEA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAZJ;AAeM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;AAbR;AAkBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EAEA,UAAA;EAGA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;AArBJ;AAwBE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gCC3HG;ED4HH,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,iDAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAtBJ;AAwBE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AAtBJ;AAuBI;EACE,+BCzII;ED0IJ,WAAA;AArBN;AAyBI;EACE,mBAAA;EACA,UAAA;EACA,mBAAA;AAvBN","sourcesContent":["@import '../../../styles/variables';\r\n\r\n.select{\r\n  $self: &;\r\n  position: relative;\r\n  width: 100%;\r\n  &.error{\r\n    #{$self}__active{\r\n      border-color:#ff0000\r\n    }\r\n  }\r\n  &__active{\r\n    display: inline-block;\r\n    width: 100%;\r\n    padding: 27px 23px 13px 23px;\r\n    background: $main;\r\n    border-radius: 8px;\r\n    //border:none;\r\n    outline: none;\r\n    z-index: 1;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    font-size: 15px;\r\n    line-height: 149.68%;\r\n    color: #F9F9F9;\r\n    transition: all 0.3s ease;\r\n    border: 1px solid #2B2B2B;\r\n    &:hover{\r\n      //background: #f5f5f5;\r\n      border-color:#EAEAEA;\r\n      //box-shadow: 0px 4px 8px 0px rgba(34, 60, 80, 0.06);\r\n      svg{\r\n        path{\r\n          stroke:#F9F9F9;\r\n        }\r\n      }\r\n    }\r\n    &:focus,&:not(:placeholder-shown){\r\n      ~ span{\r\n        font-size: 11px;\r\n        line-height: 18px;\r\n        font-weight: 600;\r\n        color:#F9F9F9;\r\n        transform: translateY(-12px);\r\n\r\n      }\r\n    }\r\n  }\r\n  input{\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    outline: none;\r\n    border:none;\r\n    display: inline-block;\r\n    width: 100%;\r\n    padding: 29px 23px 12px 23px;\r\n    background: $main;\r\n    border-radius: 8px;\r\n    //border:none;\r\n    outline: none;\r\n    z-index: 1;\r\n    font-weight: 500;\r\n    font-size: 15px;\r\n    line-height: 149.68%;\r\n    color: #F9F9F9;\r\n\r\n    &:focus,&:not(:placeholder-shown){\r\n      ~ span{\r\n        font-size: 11px;\r\n        line-height: 18px;\r\n        font-weight: 600;\r\n        color:#F9F9F9;\r\n        transform: translateY(-12px);\r\n\r\n      }\r\n    }\r\n  }\r\n  &__arrow{\r\n    position: absolute;\r\n    display: flex;\r\n    align-items: center;\r\n    right: 15px;\r\n    top: 0;\r\n    bottom:0;\r\n    margin: auto 0;\r\n\r\n  }\r\n  &__current{\r\n    margin-top: 6px;\r\n    font-weight: 400;\r\n    font-size: 15px;\r\n    line-height: 100%;\r\n    color: #F9F9F9;\r\n\r\n  }\r\n  &__label{\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 14px;\r\n    //bottom: 0;\r\n    left: 23px;\r\n   // top: 22px;\r\n\r\n    font-weight: 600;\r\n    font-size: 11px;\r\n    line-height: 120%;\r\n    color: #F9F9F9;\r\n    text-transform: uppercase;\r\n    transition: all 0.3s ease;\r\n    z-index: 2;\r\n    user-select:none;\r\n\r\n  }\r\n  &__items{\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    position: absolute;\r\n    width: 100%;\r\n    left: 0;\r\n    top:110%;\r\n    margin: 10px 0;\r\n    padding: 10px 0px;\r\n    background: $main;\r\n    border-radius: 8px;\r\n    transform: scale(0.95);\r\n    transition: all 0.3s ease;\r\n    z-index: 10;\r\n    box-shadow: 0px 4px 8px 0px rgba(34, 60, 80, 0.1);\r\n    overflow-y: auto;\r\n    max-height: 385px;\r\n    border: 1px solid #2B2B2B;\r\n  }\r\n  &__item{\r\n    padding: 16px 23px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    &:hover{\r\n      background: $accent;\r\n      color:#fff;\r\n    }\r\n  }\r\n  &.active{\r\n    #{$self}__items{\r\n      visibility: visible;\r\n      opacity: 1;\r\n      transform: scale(1);\r\n    }\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
